import { useIqamaStore } from '../state/storeIqamaDelay';
import React from 'react';
import { usePostMeta } from './usePostMeta';
import { InputSchemaValid } from '../validations/locationIsValid';
import { useConditional } from '../state/storeConditional ';

export const usePostIqama = () => {
	const [ IQFajr, SetIQFajr ] = React.useState< InputSchemaValid >();
	const [ IQDhuhr, SetIQDhuhr ] = React.useState< InputSchemaValid >();
	const [ IQAsr, SetIQAsr ] = React.useState< InputSchemaValid >();
	const [ IQMaghrib, SetIQMaghrib ] = React.useState< InputSchemaValid >();
	const [ IQIsha, SetIQIsha ] = React.useState< InputSchemaValid >();

	const updateIQFajr = useIqamaStore( ( state ) => state.updateIQFajr );
	const updateIQDhuhr = useIqamaStore( ( state ) => state.updateIQDhuhr );
	const updateIQAsr = useIqamaStore( ( state ) => state.updateIQAsr );
	const updateIQMaghrib = useIqamaStore( ( state ) => state.updateIQMaghrib );
	const updateIQIsha = useIqamaStore( ( state ) => state.updateIQIsha );
	const {isReadyGenerator,isReadyToPost } = useConditional();

	const { appendDataPost } = usePostMeta();
	React.useEffect( () => {
		if ( IQFajr?.value && isReadyGenerator && isReadyToPost ) {
			appendDataPost( IQFajr );
			SetIQFajr( { meta: '', value: '' } );
		}
		if ( IQDhuhr?.value && isReadyGenerator && isReadyToPost ) {
			appendDataPost( IQDhuhr );
			SetIQDhuhr( { meta: '', value: '' } );
		}
		if ( IQAsr?.value && isReadyGenerator && isReadyToPost ) {
			appendDataPost( IQAsr );
			SetIQAsr( { meta: '', value: '' } );
		}

		if ( IQMaghrib?.value && isReadyGenerator && isReadyToPost ) {
			appendDataPost( IQMaghrib );
			SetIQMaghrib( { meta: '', value: '' } );
		}
		if ( IQIsha?.value && isReadyGenerator && isReadyToPost ) {
			appendDataPost( IQIsha );
			SetIQIsha( { meta: '', value: '' } );
		}
	}, [ isReadyGenerator,isReadyToPost ] );
	const getInputIqama = ( data: InputSchemaValid ) => {
		if ( data.meta === 'IQFajr' ) {
			SetIQFajr( data );
			updateIQFajr( data.value as string );
		}

		if ( data.meta === 'IQDhuhr' ) {
			SetIQDhuhr( data );
			updateIQDhuhr( data.value as string );
		}
		if ( data.meta === 'IQAsr' ) {
			SetIQAsr( data );
			updateIQAsr( data.value as string );
		}

		if ( data.meta === 'IQMaghrib' ) {
			SetIQMaghrib( data );
			updateIQMaghrib( data.value as string );
		}
		if ( data.meta === 'IQIsha' ) {
			SetIQIsha( data );
			updateIQIsha( data.value as string );
		}
	};

	return { getInputIqama };
};
